import { ModalContext } from "contexts/ModalProvider";
import React from "react";

export const useModal = (): React.ContextType<typeof ModalContext> =>
  React.useContext(ModalContext);
